export default {
  navHome: "الرئيسية",
  navProducts: "المنتجات",
  navCases: "حالات التطبيق",
  navAbout: "من نحن",
  deliverTo: "التوصيل إلى:",
  langCurrencyLabel: "العربية",
  localeLangTitle: "تعيين اللغة",
  localeLangDesc:
    "اختر لغتك المفضلة. يمكنك تحديث هذا الإعداد في أي وقت.",
  language: "اللغة",
  save: "حفظ",
  coreProducts: "تمكين الإبداع في العالم الحقيقي.",
  coreProductsDesc:
    "من الفكرة إلى الأعمال �?توفر YONGYUAN طابعات UV وطابعات الملصقات الكريستالية وطابعات الأسطوانات عالية السرعة وطابعات DTF وDTG، محولة الإبداع إلى منتجات وعلامات تجارية وفرص.",
  scenariosTitle: "حلول لكل سيناريو",
  scenariosDesc:
    "سواء كنت تبني علامة تجارية أو تطور عملاً جانبياً أو تتابع شغفك الإبداعي، تقدم YONGYUAN حلاً مصمماً لاحتياجاتك.",
  scenarioStudio: "استوديو",
  scenarioStudioDesc:
    "تخصيص عالي القيمة، نماذج أولية بكميات صغيرة، وبناء العلامة التجارية",
  scenarioRetail: "تجزئة العلامات التجارية",
  scenarioRetailDesc:
    "زيادة وقت بقاء العملاء وإيرادات المتجر",
  scenarioMarket: "سوق مؤقت",
  scenarioMarketDesc:
    "تخصيص في الموقع، بيع منتجات جاهزة، ودخل إضافي",
  scenarioEnterprise: "تخصيص المؤسسات",
  scenarioEnterpriseDesc:
    "تخصيص بالجملة، منتجات العلامة التجارية، وهدايا الشركات",
  scenarioEcommerce: "البيع المباشر",
  scenarioEcommerceDesc:
    "عينات المنتجات الناجحة، توريد مرن، وإطلاق منتجات سريع",
  scenarioStore: "متجر إلكتروني",
  scenarioStoreDesc:
    "تخصيص المتجر، منتجات ناجحة، وعمليات متميزة",
  scenarioFactory: "الإنتاج في المصنع",
  scenarioFactoryDesc:
    "تصنيع بالجملة، إنتاج مستقر، وعمليات فعالة من حيث التكلفة",
  scenarioAdvertising: "إنتاج الإعلانات",
  scenarioAdvertisingDesc:
    "اللافتات، مواد العرض، ومواد الفعاليات",
  industries: "التطبيقات الصناعية",
  industriesDesc:
    "حلول الطباعة بالحبر الرقمي للطباعة الملونة عبر مختلف الصناعات.",
  applicationsTitle:
    "اكتشف تطبيقات متعددة للمواد والألوان للاحتياجات اليومية والتجارية.",
  applicationsDesc:
    "تم تصميم معدات الطباعة UV من YONGYUAN لمجموعة واسعة من المواد وسيناريوهات العمليات، مما يمكّن من التخصيص الشخصي والإنتاج واسع النطاق.",
  casesHeroDesc:
    "تغطية أكثر من 1200 تطبيق صناعي وعشرات آلاف المواد القابلة للطباعة — حلول طباعة رقمية لأعمال متنوعة.",
  casesBreadcrumbHome: "الرئيسية",
  casesBreadcrumbCenter: "حالات التطبيق",
  casesEmpty: "لا توجد حالات تطبيق في هذه الفئة بعد.",
  customerStoriesTitle: "موثوق به من قبل العملاء حول العالم",
  customerStoriesSubtitle:
    "تركيبات حقيقية، عملاء حقيقيون، أعمال طباعة حقيقية في 172 دولة.",
  customerStoriesStat1Value: "53,000+",
  customerStoriesStat1Label: "طابعات تم تسليمها",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "دولة نخدمها",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "سنوات من الخبرة",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "الدعم الفني",
  customerStoriesPlaceholder: "إضافة صورة العميل",
  customerStoriesPhotoAlt: "عميل YONGYUAN مع الطابعة",
  servicePartnerTitle:
    "تعرف على فريق خدمة YONGYUAN، شريكك الإبداعي",
  servicePartnerDesc:
    "شبكة خدمة عالمية ونظام دعم احترافي لحماية أداء معداتك ونمو أعمالك.",
  serviceSupportTitle: "الدعم القياسي",
  serviceSupportDesc:
    "إرشادات التثبيت، التدريب الأساسي، والمساعدة في الاستخدام اليومي لضمان تشغيل موثوق للمعدات.",
  servicePresaleTitle: "عرض توضيحي واستشارة ما قبل البيع",
  servicePresaleDesc:
    "عروض الحلول وتوصيات الموديلات المصممة لسيناريوهات تطبيقك ومتطلبات القدرة الإنتاجية.",
  serviceLifetimeTitle: "دعم فني مدى الحياة",
  serviceLifetimeDesc:
    "استجابة فنية مستمرة ودعم العمليات لمرافقة تطور أعمالك على المدى الطويل.",
  serviceCareTitle: "الترقية إلى YONGYUAN Care",
  serviceCareDamageTitle: "حماية من الأضرار العرضية",
  serviceCareDamageDesc:
    "خطة حماية أكثر شمولاً لتقليل الخسائر الناجمة عن الحوادث غير المتوقعة.",
  serviceCareExchangeTitle: "خدمة الاستبدال السريع",
  serviceCareExchangeDesc:
    "ترتيبات استبدال سريع ذات أولوية في ظل الشروط المؤهلة لتسريع استرداد رأس المال.",
  viewProduct: "عرض المنتجات",
  learnMore: "اعرف المزيد",
  catUv: "طابعة UV مسطحة",
  catCylinder: "طابعة أسطوانية",
  catCrystal: "طابعة ملصقات كريستالية",
  catDtf: "طابعة DTF",
  catDtg: "طابعة DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "الهاتف: 17748697567 المدير تانغ",
  email: "البريد: sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. جميع الحقوق محفوظة",
  productsHeroTitle: "المنتجات",
  productsHeroDesc:
    "مجموعة كاملة من معدات UV المسطحة والأسطوانية والملصقات الكريستالية وDTF وDTG لتلبية احتياجات القدرة الإنتاجية والتطبيق المتنوعة.",
  productsBreadcrumbHome: "الرئيسية",
  productsBreadcrumbCenter: "المنتجات",
  productsEmpty: "منتجات هذه الفئة قادمة قريباً.",
  productsQuoteTitle: "طلب حل وعرض سعر",
  productsQuoteDesc:
    "شارك سيناريوهات تطبيقك ومتطلبات القدرة الإنتاجية، وسنوصي بحل المعدات المناسب.",
  productsContact: "اتصل بنا",
  aboutHeroTitle: "عن Yongyuan",
  aboutHeroDesc:
    "23 عاماً من التركيز على البحث والتطوير وإنتاج معدات الطباعة UV",
  productA23Subtitle: "طابعة UV ذكية 6 ألوان للمكتب",
  productA23Feature1: "تنسيق طباعة A4",
  productA23Feature2: "نظام توريد حبر ذكي",
  productA23Feature3: "كشف ارتفاع تلقائي بالأشعة تحت الحمراء",
  productA35Subtitle: "طابعة UV ذكية 6 ألوان للمكتب",
  productA35Feature1: "تنسيق طباعة A3+",
  productA35Feature2: "نظام توريد حبر ذكي",
  productA35Feature3: "كشف ارتفاع تلقائي بالأشعة تحت الحمراء",
  productA43Subtitle: "طابعة UV ذكية 8 ألوان رائدة",
  productA43Feature1: "تنسيق طباعة A3",
  productA43Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA43Feature3: "نظام توريد حبر ذكي",
  productA46Subtitle: "طابعة UV ذكية 8 ألوان رائدة",
  productA46Feature1: "تنسيق طباعة A2",
  productA46Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA46Feature3: "نظام توريد حبر ذكي",
  productA57Subtitle: "طابعة UV ذكية 8 ألوان رائدة",
  productA57Feature1: "تنسيق طباعة A2+",
  productA57Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA57Feature3: "نظام توريد حبر ذكي",
  productA69Subtitle: "طابعة UV ذكية 8 ألوان رائدة",
  productA69Feature1: "تنسيق طباعة A1",
  productA69Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA69Feature3: "نظام توريد حبر ذكي",
  productA1216Subtitle: "طابعة UV مسطحة كبيرة الحجم رائدة",
  productA1216Feature1: "تنسيق طباعة 1200×1600سم",
  productA1216Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA1216Feature3: "نظام تحديد المواقع البصري",
  productA2513Subtitle: "طابعة UV مسطحة كبيرة الحجم رائدة",
  productA2513Feature1: "تنسيق طباعة 2500×1300سم",
  productA2513Feature2: "تكوينات متعددة لرؤوس الطباعة",
  productA2513Feature3: "نظام تحديد المواقع البصري",
  productCylinderElfSubtitle: "طابعة أسطوانية عالية السرعة 360°",
  productCylinderElfFeature1: "طباعة 360°",
  productCylinderElfFeature2: "تخصيص الأكواب والزجاجات",
  productCylinderElfFeature3: "تبديل سريع للتثبيتات",
  productCupPlusSubtitle: "حل طباعة أكواب وزجاجات متعددة الأحجام",
  productCupPlusFeature1: "تثبيتات متعددة الأحجام",
  productCupPlusFeature2: "كفاءة إنتاج عالية",
  productCupPlusFeature3: "إنتاج مستقر",
  productCrystal60Subtitle: "نظام متكامل لطباعة وطباعة فويل الملصقات الكريستالية",
  productCrystal60Feature1: "عرض 60سم",
  productCrystal60Feature2: "تكامل الطباعة والفويل",
  productCrystal60Feature3: "نظام التقاط فعال",
  productCrystalC60UltraFeature1: "عرض 60 سم",
  productCrystalC60UltraFeature2: "خيارات foil ذهب/فضة/ملصق سيلicone 3D",
  productCrystalC60UltraFeature3: "إنتاج جماعي",
  productCrystal30Subtitle: "طابعة ملصقات كريستالية دقيقة مدمجة",
  productCrystal30Feature1: "طباعة دقيقة مدمجة",
  productCrystal30Feature2: "سهلة التشغيل",
  productCrystal30Feature3: "تخصيص شخصي",
  productDtf60Subtitle: "طابعة نقل DTF بحبر أبيض",
  productDtf60Feature1: "نقل DTF بحبر أبيض",
  productDtf60Feature2: "طبقات ألوان غنية",
  productDtf60Feature3: "إكسسوارات الملابس",
  productDtfF20Subtitle: "أصغر طابعة DTF مكتبية بحبر أبيض في الصناعة",
  productDtfF20Feature1: "مقاس A4",
  productDtfF20Feature2: "تخصيص دفعات صغيرة",
  productDtfF20Feature3: "نظام حبر ذكي",
  productDtfF30Subtitle: "طابعة DTF مكتبية بحبر أبيض",
  productDtfF30Feature1: "مقاس A3",
  productDtfF30Feature2: "رأس واحد يدوي/آلي اختياري",
  productDtfF30Feature3: "نظام حبر ذكي",
  productDtfF30ProSubtitle: "طابعة DTF بحبر أبيض",
  productDtfF30ProFeature1: "مقاس A3",
  productDtfF30ProFeature2: "رأس مزدوج مع لف فيلم تلقائي",
  productDtfF30ProFeature3: "نظام حبر ذكي",
  productDtfF33Subtitle: "طابعة DTF بحبر أبيض",
  productDtfF33Feature1: "مقاس A3",
  productDtfF33Feature2: "رأس واحد يدوي/آلي اختياري",
  productDtfF33Feature3: "نظام حبر ذكي",
  productDtfF70ProSubtitle: "طابعة DTF بحبر أبيض بعرض 70 سم",
  productDtfF70ProFeature1: "مقاس A2",
  productDtfF70ProFeature2: "خيارات 2�? رؤوس طباعة",
  productDtfF70ProFeature3: "نظام تغذية وإخراج تلقائي",
  productDtfF70ProFeature4: "وضع استئناف الطباعة الذكي",
  productDtf30Subtitle: "طابعة DTF مدمجة بحبر أبيض",
  productDtf30Feature1: "تخصيص دفعات صغيرة",
  productDtf30Feature2: "إعادة إنتاج ألوان دقيقة",
  productDtf30Feature3: "سهلة الاستخدام",
  productDtgPrintSubtitle: "طابعة رقمية مباشرة على الملابس",
  productDtgPrintFeature1: "طباعة مباشرة متعددة المواد",
  productDtgPrintFeature2: "إنتاجية عالية",
  productDtgPrintFeature3: "مستقرة ومتينة",
  productDtg3250DSubtitle: "الطراز الوحيد 2 في 1 DTF وDTG في الصناعة",
  productDtg3250DFeature1: "مقاس A3+",
  productDtg3250DFeature2: "طباعة مزدوجة DTF وDTG",
  productDtg3250DFeature3: "نظام حبر ذكي",
  productDtg3646TSubtitle: "طابعة DTG ثنائية المحطة",
  productDtg3646TFeature1: "وضع الإنتاج المستمر",
  productDtg3646TFeature2: "زيادة الإنتاجية 100%",
  productDtg3646TFeature3: "نظام حبر ذكي",
  productDtgMaxSubtitle: "طابعة DTG رقمية صناعية",
  productDtgMaxFeature1: "قدرة إنتاجية صناعية",
  productDtgMaxFeature2: "مستقرة ومتينة",
  productDtgMaxFeature3: "تشغيل مستمر",
  app01Title: "أغطية الهواتف",
  app02Title: "كرات الغولف",
  app03Title: "لوحات حجرية",
  app04Title: "أقلام حبر",
  app05Title: "علب النظارات",
  app06Title: "طباعة خشبية",
  app07Title: "علب المشروبات",
  app08Title: "لوحات المفاتيح",
  app09Title: "أكواب حرارية",
  app10Title: "الأمتعة",
  app11Title: "منتجات أكريليك",
  app12Title: "دفاتر ملاحظات",
  app13Title: "شارات",
  app14Title: "حافظات بطاقات جلدية",
  app15Title: "لوحات تعريف",
  app16Title: "فن الزجاج",
  appDtgCase01: "تيشيرتات",
  appDtgCase02: "هوديز",
  regionCn: "الصين",
  regionUs: "الولايات المتحدة",
  regionGb: "المملكة المتحدة",
  regionDe: "ألمانيا",
  regionAe: "الإمارات",
  regionIn: "الهند",
  regionJp: "اليابان",
  regionVn: "فيتنام",
  regionBr: "البرازيل",
  regionAu: "أستراليا",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
